export default __webpack_public_path__ + "static/media/Daring Decision.8bfbcd80.png";